<div class="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 p-4">
    <div class="w-full max-w-sm">
        <div class="bg-white rounded-3xl shadow-xl shadow-slate-300/40 border border-slate-100 px-7 py-8">

            <!-- Encabezado -->
            <div class="flex flex-col items-center text-center">
                <div class="w-16 h-16 rounded-2xl bg-slate-50 ring-1 ring-slate-200 flex items-center justify-center shadow-sm">
                    <img src="/logo.ico" alt="Urbanor CRM" class="w-10 h-10 object-contain">
                </div>
                <h1 class="mt-4 text-2xl font-bold text-slate-900 tracking-tight">WhatsApp CRM</h1>
                <p class="mt-1 text-sm text-slate-400 font-medium">
                    {{ verificandoSesion ? 'Comprobando tu sesión…' : 'Inicia sesión para continuar' }}
                </p>
            </div>

            <!-- Mientras se comprueba la sesión no se piden credenciales: si ya hay
                 sesión válida, se entra directo y el formulario ni llega a verse. -->
            <div *ngIf="verificandoSesion" class="mt-8 flex flex-col items-center gap-3 py-6">
                <lucide-icon name="loader-2" class="h-6 w-6 text-slate-300 animate-spin"></lucide-icon>
                <p class="text-xs text-slate-400">Si ya iniciaste sesión, entrarás automáticamente.</p>
            </div>

            <ng-container *ngIf="!verificandoSesion">

            <app-alert *ngIf="errorMsg" type="error" [visible]="true" [dismissible]="true" (closed)="errorMsg = ''"
                class="block mt-6">
                {{ errorMsg }}
            </app-alert>

            <!-- PRINCIPAL: botón propio de Google (popup) -->
            <button *ngIf="googleEnabled" type="button" (click)="loginWithGoogle()" [disabled]="isLoading"
                class="mt-6 w-full flex items-center justify-center gap-3 py-3 px-4 rounded-xl bg-[#1a73e8] hover:bg-[#1765cc] text-white text-sm font-semibold shadow-sm shadow-blue-500/20 transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
                <span class="flex items-center justify-center bg-white rounded-md p-1">
                    <svg viewBox="0 0 48 48" class="w-4 h-4">
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                    </svg>
                </span>
                {{ isLoading ? 'Conectando…' : 'Continuar con Google' }}
            </button>

            <!-- Enlace para desplegar el inicio con correo -->
            <div *ngIf="googleEnabled && !showEmailForm" class="mt-4 text-center">
                <button type="button" (click)="toggleEmailForm()"
                    class="text-sm text-slate-500 hover:text-slate-700 font-medium underline underline-offset-4 decoration-slate-300 hover:decoration-slate-500 transition-colors">
                    o inicia sesión con tu cuenta
                </button>
            </div>

            <!-- SECUNDARIO: correo y contraseña (oculto hasta pulsar el enlace) -->
            <form *ngIf="showEmailForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()"
                class="flex flex-col gap-4" [class.mt-6]="googleEnabled" [class.mt-2]="!googleEnabled">

                <div *ngIf="googleEnabled" class="relative">
                    <div class="absolute inset-0 flex items-center">
                        <div class="w-full border-t border-slate-200"></div>
                    </div>
                    <div class="relative flex justify-center text-xs">
                        <span class="px-3 bg-white text-slate-400 font-medium">o ingresa con tu correo</span>
                    </div>
                </div>

                <app-input id="email" type="email" label="Correo electrónico" placeholder="tu@empresa.com" icon="mail"
                    formControlName="email">
                </app-input>

                <app-input id="password" type="password" label="Contraseña" placeholder="••••••••" icon="lock"
                    formControlName="password">
                </app-input>

                <div class="flex items-center">
                    <input id="remember-me" name="remember-me" type="checkbox"
                        class="h-4 w-4 text-slate-800 focus:ring-slate-700 border-slate-300 rounded cursor-pointer">
                    <label for="remember-me" class="ml-2 block text-sm text-slate-600 cursor-pointer">Recordarme</label>
                </div>

                <button type="submit" [disabled]="loginForm.invalid || isLoading"
                    class="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-xl text-sm font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                    <lucide-icon *ngIf="isLoading" name="loader-2" class="w-5 h-5 animate-spin"></lucide-icon>
                    <lucide-icon *ngIf="!isLoading" name="log-in" class="w-5 h-5"></lucide-icon>
                    Iniciar Sesión
                </button>
            </form>

            </ng-container>

            <p class="mt-7 text-center text-[11px] text-slate-400 font-medium">
                Acceso restringido al personal de URBANOR SA
            </p>
        </div>

        <p class="mt-6 text-center text-xs text-slate-400 font-medium">
            &copy; {{ currentYear }} Urbanor App. Todos los derechos reservados.
        </p>
    </div>
</div>
